import type { EmployeeSummary } from '../types/models';

type EmployeeLike = Pick<EmployeeSummary, 'status'> & {
  hireDate?: string | null;
  retirementDate?: string | null;
};

/**
 * 期間内に在籍していた(在籍経験がある)従業員かを判定
 *   - 退職日が期間開始より前 → 期間内に在籍していない
 *   - 入社日が期間終了より後 → 期間内に在籍していない
 *   - status=retired かつ retirementDate 未設定 → 退職日不明なので除外
 *   それ以外は期間内に在籍していたとみなす(在籍中・退職者どちらも対象)
 */
export function isActiveInPeriod(
  emp: EmployeeLike,
  periodStart: string,
  periodEnd: string
): boolean {
  if (emp.hireDate && emp.hireDate > periodEnd) return false;
  if (emp.retirementDate && emp.retirementDate < periodStart) return false;
  if (emp.status === 'retired' && !emp.retirementDate) return false;
  return true;
}
